<template>
  <div>
    <s-processing v-model="processing" :message="message"></s-processing>
    <!--CIRCUITO DE APRBACIONES MODAL-->
    <div v-if="dialogCircuit">
      <v-dialog v-model="dialogCircuit" width="80%" persistent>
        <s-toolbar color="primary" dark label="Circuitos Asociados a la Operación" @close="dialogCircuit = false"
          close></s-toolbar>
        <v-card>
          <v-container>
            <v-row>
              <v-col lg="7">
                <v-text-field v-model="searchCircuit" append-icon="mdi-magnify" label="Buscar circuito..." single-line
                  hide-details class="mb-3"></v-text-field>
                <v-data-table dense item-key="AccID" :items="circuits" height="320" :headers="[
                  { value: 'AccID', text: 'ID' },
                  { value: 'AccName', text: 'Circuito' },
                ]" :search="searchCircuit" @dblclick:row="createCircuit" v-model="selectedCircuit"
                  @click:row="rowClickCircuit" />
              </v-col>
              <v-col lg="5">
                <s-crud v-if="this.filterLevels.AccID != null" no-toolbar :config="configLevels" :filter="filterLevels"
                  title="Niveles" />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
    <div>
      <s-toolbar :load="orderLocal.OrdStatus == 1" close :save="value == null || orderLocal.OrdStatus == 3"
        @save="save()" label="Nueva Orden de Compra" @close="$emit('onClose')"
        :transactionApproved="transactionApproved" @load="loadExternal()" />
      <v-card>
        <v-col>
          <v-row>
            <v-col lg="9" cols="12">
              <v-col class="pr-0 pl-0">
                <v-row>
                  <v-col class="s-col-text" cols="12" lg="5">
                    <s-supplier :readonly="!isEditable" label="Proveedor" v-model="Supplier" />
                  </v-col>
                  <v-col lg="3" class="s-col-text" cols="12"><s-contact-supplier :disabled="!isEditable"
                      label="Contacto" :SupID="SupID" v-model="orderLocal.ConID" /></v-col>
                  <v-col lg="2" class="s-col-text" cols="6"><s-select-definition :disabled="!isEditable" :def="1129"
                      label="Moneda" v-model="orderLocal.TypeCurrency" /></v-col>
                  <v-col lg="2" class="s-col-text"><s-date label="Fecha" v-model="dateOrder"
                      :disabled="!isEditable"></s-date></v-col>
                </v-row>
              </v-col>
              <v-row>
                <v-col>
                  <div class="mt-3 mb-3">
                    <s-toolbar :elevation="1" label="Detalles" :add="isEditable" @add="addItem()" with="20"
                      :remove="isEditable" @removed="removeItem()">
                      <template v-slot:options>
                        <div class="mt-1">
                          <s-select :outlined="false" :items="[
                            { value: 1, text: 'Articulo' },
                            { value: 3, text: 'Servicio' },
                          ]" v-model="orderLocal.TypeOrder"></s-select>
                        </div>
                      </template>
                    </s-toolbar>
                  </div>
                  <v-data-table dense @click:row="rowClick" :headers="headersSAP" :items-per-page="-1"
                    v-model="selectedSAP" :items="itemsSAP" item-key="Line" :height="300" hide-default-footer>
                    <template v-slot:item.OddDescription="props">
                      <div>
                        <s-text v-if="orderLocal.TypeOrder == 3" :maxlength="100" autofocus
                          v-model="props.item.OddDescription"></s-text>
                        <s-article v-if="orderLocal.TypeOrder == 1" label="" return-object
                          @input="inputArticle($event, props.item)" v-model="props.item.ArticleObj"></s-article>
                      </div>
                    </template>
                    <template v-slot:item.TypeCostName="props">
                      <div>
                        <s-select-definition v-if="isEditable" abbr :def="1045" v-model="props.item.TypeCost" />
                        <div v-else>
                          <div>{{ props.item.TypeCostName }}</div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.BslName="props">
                      <div>
                        <!-- $fun.hasSpecialPermission("AllLine")==true?1-->
                        <s-select-business-line v-if="isEditable" label=""
                          :cceID='props.item.CceID == null ? 0 : props.item.CceID' v-model="props.item.BslID" />
                        <div v-else>
                          <div>{{ props.item.BslName }}</div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.PrjName="props">
                      <div>
                        <s-select-project label="" v-if="isEditable" v-model="props.item.PrjCode" />
                        <div v-else>
                          <div>{{ props.item.PrjCode }}</div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.OddObservation="props">
                      <div>
                        <s-text label="" v-if="isEditable" v-model="props.item.OddObservation" />
                        <div v-else>
                          <div>{{ props.item.OddObservation }}</div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.CceName="props">
                      <div>
                        <s-select-area v-if="isEditable" centercost return-object
                          @input="inputCenterCost($event, props.item)" v-model="props.item.CceObject" />
                        <div v-else>
                          <div>{{ props.item.CceName }}</div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.TaxCode="props">
                      <div>
                        <v-edit-dialog v-if="isEditable" large @click="selectedSAP = [props.item]"
                          cancel-text="Cancelar" save-text="Guardar" @save="changeTax(props.item)">
                          <v-row @click="selectedSAP = [props.item]">
                            <v-col>
                              <div>{{ props.item.TaxCode }}</div>
                            </v-col>
                          </v-row>
                          <template v-slot:input>
                            <div class="mt-4 title mb-4">
                              Selecciona Impuesto
                            </div>
                            <s-select-definition id="DedAbbreviation" return-object :def="1143" v-model="tax" />
                          </template>
                        </v-edit-dialog>
                        <div v-else>
                          <div>{{ props.item.TaxCode }}</div>
                        </div>
                      </div>
                    </template>

                    <template v-slot:item.OddUnitPrice="props">
                      <s-text style="width: 75px" decimal :maxDecimal="6" @input="changeItem(props.item)"
                        :disabled="!isEditable" @paste="pastePrice($event)" v-model="props.item.OddUnitPrice">
                        Precio Unitario
                      </s-text>
                    </template>
                    <template v-slot:item.OddQuantity="props">
                      <s-text style="width: 80px" @blur="blurQuantity($event, props.item)" :disabled="!isEditable"
                        decimal @paste="pasteQuantity($event)" v-model="props.item.OddQuantity">
                        Cantidad Atendida
                      </s-text>
                    </template>
                    <template v-slot:item.AcoName="props">
                      <v-edit-dialog large v-if="isEditable" @save="saveAccount(props.item)" cancel-text="Cancelar"
                        save-text="Guardar">
                        <div>{{ props.item.AcoName }}</div>
                        <template v-slot:input>
                          <div class="mt-4 mb-4">
                            Concepto - Cuenta Contable
                          </div>
                          <s-select item-value="ConName" clearable item-text="ConName" label="Concepto Servicio"
                            v-model="ConName" :items="itemsConcept" />
                          <s-select label="Cuenta Contable" clearable item-value="CsaID" return-object
                            item-text="CsaDescription" v-model="AcoID" :items="itemsAccount" />
                        </template>
                      </v-edit-dialog>
                      <div v-else>
                        <div>{{ props.item.AcoName }}</div>
                      </div>
                    </template>

                    <template v-slot:item.OddDiscountPercentage="props">
                      <s-text label="" v-model="props.item.OddDiscountPercentage" @input="changeItemPrc(props.item)"
                        decimal :disabled="!isEditable" :maxDecimal="3"></s-text>
                    </template>

                    <template v-slot:item.OddDiscount="props">
                      <span>{{ props.item.OddDiscount | numberDefault }}</span>
                    </template>

                    <template v-slot:item.OddTaxAmount="props">
                      <span>{{ props.item.OddTaxAmount | numberDefault }}</span>
                    </template>

                    <template v-slot:item.OddAmount="props">
                      <s-text v-if="isEditable" label="" v-model="props.item.OddAmount" @input="changeSubTotal(props.item, $event)"
                        decimal></s-text>
                      <span v-else>{{ props.item.OddAmount | numberDefault }}</span>
                    </template>

                  </v-data-table>
                </v-col>
              </v-row>
              <v-col style="padding-top: 24px">
                <v-row>
                  <v-col lg="8" cols="12">
                    <v-row>
                      <v-col lg="8" class="s-col-form">
                        <s-select-definition :def="1145" label="Encargado de Compras" :disabled="!isEditable"
                          v-model="orderLocal.OfficePurchase" />
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col lg="8" class="s-col-form">
                            <s-select-paymentterms v-model="orderLocal.PytID" label="Condición de Pago" />
                        </v-col>
                    </v-row>
                  </v-col>
                  <v-col lg="4">
                    <v-card flat class="pa-2" outlined>
                      <!-- SUB-TOTAL -->
                      <v-row dense align="center" no-gutters class="py-1">
                        <v-col cols="6">
                          <span class="text-body-2">SUB-TOTAL</span>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <span class="font-weight-bold">
                            {{ orderLocal.OrdSubTotal | numberDefault }}
                          </span>
                        </v-col>
                      </v-row>

                      <v-divider></v-divider>

                      <!-- DESCUENTO -->
                      <v-row dense align="center" no-gutters class="py-1">
                        <v-col cols="3" class="d-flex align-center">
                          <span class="text-body-2">DESCUENTO</span>
                        </v-col>
                        <v-col cols="4" class="px-1">
                          <s-text v-model="orderLocal.OrdDiscountPercentage" @input="calculateTotals()" decimal
                            :disabled="!isEditable" dense outlined hide-details :maxDecimal="3" suffix="%"></s-text>
                        </v-col>
                        <v-col cols="5" class="pl-1">
                          <s-text v-model="orderLocal.OrdDiscountAmount" @input="calculatePercent()" decimal
                            :disabled="!isEditable" dense outlined hide-details suffix="$"></s-text>
                        </v-col>
                      </v-row>

                      <v-divider></v-divider>

                      <!-- IMPUESTO -->
                      <v-row dense align="center" no-gutters class="py-1">
                        <v-col cols="6">
                          <span class="text-body-2">IMPUESTO</span>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <span class="font-weight-bold">
                            {{ orderLocal.OrdTaxAmount | numberDefault }}
                          </span>
                        </v-col>
                      </v-row>

                      <v-divider></v-divider>

                      <!-- TOTAL -->
                      <v-row dense align="center" no-gutters class="primary lighten-5 py-2 px-2">
                        <v-col cols="6">
                          <span class="font-weight-bold">TOTAL</span>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <span class="text-h6 font-weight-bold primary--text">
                            {{ orderLocal.OrdTotal | numberDefault }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col lg="3" cols="12">
              <v-card elevation="0" height="520">
                <v-col class="">
                  <v-row><v-col class="s-col-text"><s-select-Campaign :disabled="!isEditable" label="Campaña"
                        v-model="orderLocal.CmpID" /></v-col>
                  </v-row>
                  <v-row><v-col class="s-col-text"><s-text label="N° Cotización" :maxlength="20" :disabled="!isEditable"
                        v-model="orderLocal.QuoteNumber" /></v-col></v-row>
                  <v-row>
                    <v-col class="s-col-text"><s-select-definition :disabled="!isEditable" label="Clase de Operación"
                        v-model="orderLocal.ClassOperationPurchase" :def="1147" /></v-col>
                  </v-row>
                  <v-row>
                    <v-col class="s-col-text"><s-select-definition :disabled="!isEditable" label="Tipo Compra"
                        :def="1146" v-model="orderLocal.TypePurchase" /></v-col>
                  </v-row>
                  <v-row>
                    <v-col lg="12" class="s-col-form" cols="12">
                      <s-select clearable label="Bienes y Servicios" :items="goodServiceList" item-text="DedDescription"
                        item-value="DedValue" v-model="orderLocal.OrdGoodService" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="s-col-text"><s-textarea :disabled="!isEditable" label="Comentarios"
                        v-model="orderLocal.OrdObservation" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col lg="12" cols="12" class="s-col-text">
                      <v-row>
                        <v-col lg="10"><v-file-input :disabled="!isEditable" label="Anexo 01" v-model="Attach1"
                            hide-details /></v-col>
                        <v-col><v-btn color="success" class="mt-5" :disabled="false" icon x-small
                            @click="openFile(Attach1)">
                            <v-icon>mdi-download</v-icon>
                          </v-btn></v-col>
                      </v-row>
                    </v-col>
                    <v-col lg="12" cols="12" class="s-col-text">
                      <v-row>
                        <v-col lg="10"><v-file-input :disabled="!isEditable" label="Anexo 02" v-model="Attach2"
                            hide-details /></v-col>
                        <v-col><v-btn color="success" class="mt-5" :disabled="false" icon x-small
                            @click="openFile(Attach2)">
                            <v-icon>mdi-download</v-icon>
                          </v-btn></v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="12" class="s-col-text">
                      <v-row>
                        <v-col lg="10"><v-file-input :disabled="!isEditable" label="Anexo 03" v-model="Attach3"
                            hide-details /></v-col>
                        <v-col><v-btn color="success" class="mt-5" :disabled="false" icon x-small
                            @click="openFile(Attach3)">
                            <v-icon>mdi-download</v-icon>
                          </v-btn></v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="12" class="s-col-text">
                      <v-row>
                        <v-col lg="10"><v-file-input :disabled="!isEditable" label="Anexo 04" v-model="Attach4"
                            hide-details /></v-col>
                        <v-col><v-btn color="success" class="mt-5" :disabled="false" icon x-small
                            @click="openFile(Attach4)">
                            <v-icon>mdi-download</v-icon>
                          </v-btn></v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </div>
  </div>
</template>

<!-- </s-crud></v-col> </v-row>
 </div>
</template> -->

<script>
import DataTableItem from "@/views/Logistics/OrderPurchase/DataTableItem.vue"; // importado para tipo copiado de Excel
import OrderAttentionPurchase from "@/views/Logistics/OrderStore/OrderPurcharseAttentionAdd.vue";
import OrderAttentionService from "@/views/Logistics/Requirement/ServiceAttentionAdd.vue";
import _sApprovalTransaction from "../../../services/Security/ApprovalTransactionService";
import SContactSupplier from "../../../components/Utils/Logistics/SContactSupplier.vue";
import SSupplier from "../../../components/Utils/Logistics/SSupplier.vue";
import _sRequirementDetail from "../../../services/Logistics/RequirementDetailService";
import _sRequirement from "../../../services/Logistics/RequirementService";
import _sGeneral from "@/services/HelperService.js";
import _sOrderPurchase from "../../../services/Logistics/OrderPurchaseService";
import SCircuitApproval from "../../../components/Utils/Security/SCircuitApproval.vue";
import _sApprovalLevel from "@/services/Security/ApprovalLevelsService";
import SSelectBusinessLine from "../../../components/Utils/SSelectBusinessLine.vue";
import SSelectDefinition from "../../../components/Utils/SSelectDefinition.vue";
import SArticle from "@/components/Utils/Logistics/SArticleSearch.vue";
import TrsBudgeService from '@/services/Treasury/TrsBudgeService';
import TrsBudgetDetailService from '@/services/Treasury/TrsBudgetDetailService';
import _sGenParam from "@/services/General/ParameterService";
import _sOtherSupportService from "@/services/Security/OtherSupportService";
import SSelectPaymentterms from "../../../components/logistics/SSelectPaymentterms.vue";

export default {
  components: {
    SSupplier,
    SContactSupplier,
    SArticle,
    SCircuitApproval,
    SSelectBusinessLine,
    SSelectDefinition,
    OrderAttentionPurchase,
    OrderAttentionService,
    SSelectPaymentterms
  },
  props: { order: {}, value: null },
  data: () => ({
    goodServiceList: [],
    ValidateBudget: 0,
    typeOrder: null,
    item: {
      OddDescription: "",
      ArtCode: "",
    },
    selectedTax: false,
    circuits: [],
    message: "",
    processing: false,
    selectedCircuit: [],
    filterLevels: {},
    configLevels: {
      model: {
        AccID: "int",
        AlvID: "ID",
        SecStatus: "boleam",
        PstID: "int",
        PstName: "string",
      },
      service: _sApprovalLevel,
      headers: [
        { text: "Cargo", value: "PstName" },
        { text: "Nivel", value: "TypeLevelText" },
      ],
    },
    optionApproved: false,
    dateOrder: null,
    selectedSAP: [],
    transactionApproved: null,
    tax: null,
    dialogCircuit: false,
    searchCircuit: "",

    orderLocal: { TypeOrder: null },
    dialogAdd: false,
    itemsConcept: [],
    itemsAccount: [],
    AcoID: null,
    ConID: null,
    ConName: null,
    SupID: "",
    Supplier: null,
    itemsSAP: [],
    itemsRemove: [],
    dialogLoad: false,
    Attach1: null,
    Attach2: null,
    Attach3: null,
    Attach4: null,
    headersSAP: [
      { text: "Descripción", value: "OddDescription", sortable: false, width: 540, },
      { text: "Cuenta Mayor", value: "AcoName", width: 220, sortable: false },
      { text: "Prc. U.", value: "OddUnitPrice", sortable: false, width: 90 },
      { text: "% Descuento", value: "OddDiscountPercentage", sortable: false, width: 90 },
      { text: "Monto Desc.", value: "OddDiscount", sortable: false, width: 90, align: "right" },
      { text: "Impuesto", value: "TaxCode", sortable: false, width: 60 },
      { text: "(%)Imp", value: "OddTaxPercentage", sortable: false, width: 70 },
      { text: "SubTotal", value: "OddAmount", sortable: false, width: 100, align: "right", },
      { text: "Centro Costo", value: "CceName", sortable: false, width: 300 },
      { text: "Linea de Negocio", value: "BslName", sortable: false, width: 300, },
      { text: "Tipo Costo", value: "TypeCostName", sortable: false, width: 100, },
      { text: "Proyecto", value: "PrjName", sortable: false, width: 300 },
      { text: "Comentario", value: "OddObservation", sortable: false, width: 400, },
    ],
    ordData: {},
    numberDefault: '0.00'
  }),
  computed: {
    isEditable() {
      return ((this.orderLocal.OrdStatus == 3 && this.$fun.getUserID() == this.orderLocal.UsrCreateID) || this.orderLocal.OrdID == null);
    },
  },
  methods: {
    getGoodServiceList() {
      _sRequirement.goodservicelist(this.$fun.getUserID()).then(resp => {
        if (resp.status == 200) {
          this.goodServiceList = resp.data;
        }
      })
    },

    inputArticle(article, item) {
      // console.log("article:",article);
      item.UnitMeasurement = article.UnitOfMeasuarement;
      item.ArtCode = article.ArtCode;
      item.OddDescription = article.ArtName;
      item.ItemGroupName = article.ItemGroupName;
    },
    inputCenterCost(center, item) {
      if (center) item.CceID = center.GenID;
      else item.CceID = 0;
    },
    addItem() {
      this.item.Line = this.itemsSAP.length + 1;
      this.item.OddStatus = 1;  // campo en observación
      this.itemsSAP.push({ ...this.item });
      // console.log('agregamos items', this.itemsSAP); 
    },
    openFile(url) {
      _sGeneral.download(url.name, this.$fun.getUserID()).then((r) => {
        if (r.status === 200) {
          this.$fun.downloadHttp(r);
        }
      });
      /*  let showM = 0;
        _sGeneral.download(url.name, this.$fun.getUserID()).then((r) => {
          if(r.status === 200){
            this.$fun.downloadHttp(r);
            showM = 1;
          }       
        });
        .catch(error => {
          console.log("error samir",error)
        });
  
        if(showM == 0){ 
          alert("NO se encontro el Archivo","warning")
          console.log("showM", showM)
          };
  */
    },

    selectedAttention(items) {
      // console.log("selectedAttention:",items);
      for (let i = 0; i < items.length; i++) {
        items[i].OddDescription = items[i].DerDescription;
        items[i].OddQuantity = items[i].DerQuantity;
        items[i].Line = i + this.itemsSAP.length + 1;
      }
      this.itemsSAP.push(...items);
      this.dialogAdd = false;
    },

    removeItem() {
      if (this.selectedSAP.length == 1) {
        if (this.itemsSAP.length <= 1) {
          this.$fun.alert(
            "No se permite eliminar el ultimo item de la orden",
            "warning"
          );
          return;
        }
        this.itemsSAP = this.itemsSAP.filter(
          (x) => x.Line != this.selectedSAP[0].Line
        );
        this.selectedSAP[0].OddStatus = 0;

        if (this.selectedSAP[0].OddID > 0)
          this.itemsRemove.push(this.selectedSAP[0]);
        //this.selectedSAP[0]=this.itemsSAP[0];
        this.changeTotal();
      }
    },

    blurQuantity(event, item) {
      if (item.DerQuantity < item.OddQuantity || item.OddQuantity <= 0) {
        this.$fun.alert("Cantidad Incorrecta", "warning");
        item.OddQuantity = item.DerQuantity;
        this.changeItem(item);
        //this.itemsSAP.splice(this.itemsSAP.indexOf(item),1,item);
      }
      this.changeItem(item);
    },

    pasteQuantity(event) {

      event.preventDefault();
      let quantitys = [];
      let i = 0;
      let isValid = true;
      event.clipboardData
        .getData("text/plain")
        .split("\n")
        .forEach((element) => {
          if (element.trim() != "") {
            quantitys[i] = parseFloat(element.trim());
            if (Number.isNaN(quantitys[i])) {
              this.$fun.alert("Datos incorrectos", "warning");
              isValid = false;
            }
            i++;
          }
        });

      if (isValid == true)
        for (i = 0; i < this.itemsSAP.length && i < quantitys.length; i++) {
          this.itemsSAP[i].OddQuantity = quantitys[i];
          this.changeItem(this.itemsSAP[i]);
        }
    },
    pastePrice(event) {

      event.preventDefault();
      let quantitys = [];
      let i = 0;
      let isValid = true;
      event.clipboardData
        .getData("text/plain")
        .split("\n")
        .forEach((element) => {
          if (element.trim() != "") {
            quantitys[i] = parseFloat(element.trim());
            if (Number.isNaN(quantitys[i])) {
              this.$fun.alert("Datos incorrectos", "warning");
              isValid = false;
            }
            i++;
          }
        });
      if (isValid == true)
        for (i = 0; i < this.itemsSAP.length && i < quantitys.length; i++) {
          this.itemsSAP[i].OddUnitPrice = this.trimDecimals(quantitys[i], 6);
          this.changeItem(this.itemsSAP[i]);
        }
    },

    trimDecimals(value, maxDecimals) {
      if (value === null || value === undefined || value === "") return value;
      let n = Number(String(value).replace(/,/g, '.'));
      if (Number.isNaN(n)) return value;
      const factor = Math.pow(10, maxDecimals);
      return Math.round(n * factor) / factor;
    },

    changeTotal() {
      this.calculateTotals();
    },

    calculatePercent() {
      let sOrdTotal = 0;
      let sOrdTaxAmount = 0;

      this.itemsSAP.forEach((element) => {
        let itemTotal = parseFloat(element.OddAmount || 0);
        let itemTax = parseFloat(element.OddTaxAmount || 0);

        if (!element.OddAmount) {
          let price = parseFloat(element.OddUnitPrice || 0);
          let qty = parseFloat(element.OddQuantity || 1);
          itemTotal = price * qty;
          let taxP = parseFloat(element.OddTaxPercentage || 0);
          itemTax = itemTotal * (taxP / 100);
          itemTotal += itemTax;
        }

        sOrdTotal += itemTotal;
        sOrdTaxAmount += itemTax;
      });

      let ordSubTotal = sOrdTotal - sOrdTaxAmount;
      let generalDiscountAmount = parseFloat(this.orderLocal.OrdDiscountAmount || 0);

      let generalDiscountPercent = 0;
      if (ordSubTotal !== 0) {
        generalDiscountPercent = (generalDiscountAmount / ordSubTotal) * 100;
      }

      let effectiveTaxAmount = sOrdTaxAmount * (1 - generalDiscountPercent / 100);
      let finalTotal = (ordSubTotal - generalDiscountAmount) + effectiveTaxAmount;

      this.orderLocal.OrdDiscountPercentage = parseFloat(generalDiscountPercent.toFixed(4));
      this.orderLocal.OrdSubTotal = parseFloat(ordSubTotal.toFixed(4));
      this.orderLocal.OrdTaxAmount = parseFloat(effectiveTaxAmount.toFixed(4));
      this.orderLocal.OrdTotal = parseFloat(finalTotal.toFixed(4));
    },

    calculateTotals() {
      let sOrdTotal = 0;
      let sOrdTaxAmount = 0;

      this.itemsSAP.forEach((element) => {
        let itemTotal = parseFloat(element.OddAmount || 0);
        let itemTax = parseFloat(element.OddTaxAmount || 0);

        if (!element.OddAmount) {
          let price = parseFloat(element.OddUnitPrice || 0);
          let qty = parseFloat(element.OddQuantity || 1);
          itemTotal = price * qty;
          let taxP = parseFloat(element.OddTaxPercentage || 0);
          itemTax = itemTotal * (taxP / 100);
          itemTotal += itemTax;
        }

        sOrdTotal += itemTotal;
        sOrdTaxAmount += itemTax;
      });

      let ordSubTotal = sOrdTotal - sOrdTaxAmount;

      let generalDiscountPercent = parseFloat(this.orderLocal.OrdDiscountPercentage || 0);
      let generalDiscountAmount = ordSubTotal * (generalDiscountPercent / 100);

      let effectiveTaxAmount = sOrdTaxAmount * (1 - generalDiscountPercent / 100);
      let finalTotal = (ordSubTotal - generalDiscountAmount) + effectiveTaxAmount;

      this.orderLocal.OrdDiscountAmount = generalDiscountAmount.toFixed(2);
      this.orderLocal.OrdSubTotal = parseFloat(ordSubTotal.toFixed(4));
      this.orderLocal.OrdTaxAmount = parseFloat(effectiveTaxAmount.toFixed(4));
      this.orderLocal.OrdTotal = parseFloat(finalTotal.toFixed(4));
    },

    changeItemPrc(item) {
      let discountPerc = parseFloat(item.OddDiscountPercentage || 0);
      if (discountPerc < 0) discountPerc = 0;
      if (discountPerc > 100) discountPerc = 100;

      let price = parseFloat(item.OddUnitPrice || 0);
      let quantity = parseFloat(item.OddQuantity || 0);
      let taxPerc = parseFloat(item.OddTaxPercentage || 0);

      let grossAmount = price * quantity;
      let discountAmount = grossAmount * (discountPerc / 100);
      let netSubTotal = grossAmount - discountAmount;

      let taxAmount = netSubTotal * (taxPerc / 100);
      let totalAmount = netSubTotal + taxAmount;

      item.OddTaxAmount = taxAmount.toFixed(2);
      item.OddAmount = totalAmount.toFixed(2);
      item.OddDiscount = discountAmount.toFixed(2);

      this.calculateTotals();

      this.$forceUpdate();
    },

    changeItemDiscount(item) {
      let discountAmount = parseFloat(item.OddDiscount || 0);
      let price = parseFloat(item.OddUnitPrice || 0);
      let quantity = parseFloat(item.OddQuantity || 0);
      let taxPerc = parseFloat(item.OddTaxPercentage || 0);

      let grossAmount = price * quantity;
      let discountPerc = 0;
      if (grossAmount > 0) {
        discountPerc = (discountAmount / grossAmount) * 100;
      }
      if (discountPerc < 0) discountPerc = 0;
      if (discountPerc > 100) discountPerc = 100;

      let netSubTotal = grossAmount - discountAmount;
      let taxAmount = netSubTotal * (taxPerc / 100);
      let totalAmount = netSubTotal + taxAmount;

      item.OddDiscountPercentage = parseFloat(discountPerc.toFixed(3));
      item.OddTaxAmount = taxAmount.toFixed(2);
      item.OddAmount = totalAmount.toFixed(2);

      this.calculateTotals();

      this.$forceUpdate();
    },

    changeItem(item) {

      this.orderLocal.OrdSubTotal = 0;
      this.orderLocal.OrdTaxAmount = 0;
      let edit = Object.assign(
        {},
        this.itemsSAP.find((x) => x.Line == item.Line)
      );
      if (edit.OddUnitPrice !== null && edit.OddUnitPrice !== undefined && edit.OddUnitPrice !== "") {
        edit.OddUnitPrice = this.trimDecimals(edit.OddUnitPrice, 6);
      }

      let indexEdit = this.itemsSAP.indexOf(item);
      if (edit.CceObject) {
        let cce = edit.CceID;
        edit.CceID = edit.CceObject.GenID;
        edit.CceName = edit.CceObject.GenDescription;
        if (edit.CceObject.GenID != cce) {
          edit.BslID = null;
          edit.BslName = "";
        } else {
          if (edit.BslObject) {
            edit.BslID = edit.BslObject.GenID;
            edit.BslName = edit.BslObject.GenDescription;
          }
        }
      }
      if (edit.TypeCostObject) {
        edit.TypeCost = edit.TypeCostObject.DedValue;
        edit.TypeCostName = edit.TypeCostObject.DedDescription;
      }

      let price = parseFloat(edit.OddUnitPrice || 0);
      let quantity = parseFloat(edit.OddQuantity || 0);
      if (this.orderLocal.TypeOrder == 3 && quantity === 0) {
        quantity = 1;
        edit.OddQuantity = 1;
      }
      let discountPerc = parseFloat(edit.OddDiscountPercentage || 0);
      let taxPerc = parseFloat(edit.OddTaxPercentage || 0);

      let grossAmount = price * quantity;
      if (discountPerc === 0 && parseFloat(edit.OddDiscount || 0) > 0 && grossAmount > 0) {
        discountPerc = (parseFloat(edit.OddDiscount) / grossAmount) * 100;
        edit.OddDiscountPercentage = parseFloat(discountPerc.toFixed(3));
      }
      let discountAmount = grossAmount * (discountPerc / 100);
      let netSubTotal = grossAmount - discountAmount;

      let taxAmount = netSubTotal * (taxPerc / 100);
      let totalAmount = netSubTotal + taxAmount;

      edit.OddTaxAmount = taxAmount.toFixed(2);
      edit.OddAmount = totalAmount.toFixed(2);
      edit.OddDiscount = discountAmount.toFixed(2);

      this.itemsSAP.splice(indexEdit, 1, edit);

      this.calculateTotals();

    },

    changeSubTotal(item, newValue) {
      if (newValue !== undefined) {
        item.OddAmount = newValue;
      }
      if (item.OddAmount === "" || item.OddAmount == null) return;

      let subTotalTotal = parseFloat(item.OddAmount);
      let price = parseFloat(item.OddUnitPrice || 0);
      let quantity = parseFloat(item.OddQuantity || 0);
      let taxPercent = parseFloat(item.OddTaxPercentage || 0);

      let grossAmount = price * quantity;
      if (grossAmount === 0) return;

      let taxFactor = 1 + (taxPercent / 100);
      let netSubTotal = subTotalTotal / taxFactor;

      let discountAmount = grossAmount - netSubTotal;
      let discountPercent = (discountAmount / grossAmount) * 100;

      if (discountPercent < 0) discountPercent = 0;
      if (discountPercent > 100) discountPercent = 100;

      item.OddDiscountPercentage = discountPercent.toFixed(4);

      item.OddTaxAmount = (netSubTotal * (taxPercent / 100)).toFixed(2);

      this.calculateTotals();
      this.$forceUpdate();
    },

    rowClick: function (item, row) {
      this.selectedSAP = [item];
    },

    saveAccount(item) {
      // console.log("Item ED:", item, this.AcoID);
      if (this.AcoID != null) {
        let edit = this.itemsSAP.find((x) => x.Line == item.Line);
        let indexEdit = this.itemsSAP.indexOf(item);
        edit.AcoName = this.AcoID.CsaDescription;
        edit.OddAccount = this.AcoID.CsaAccount;
        edit.OddAccountName = this.AcoID.CsaAccountName;
        this.itemsSAP.splice(indexEdit, 1, edit);
      }
    },
    changeTax(item) {
      if (this.tax != null)
        if (this.selectedTax) {
          item.OddTaxPercentage = parseFloat(this.tax.DedHelper).toFixed(4);
          item.TaxCode = this.tax.DedAbbreviation;
          this.changeItem(item);
          this.tax = null;
        } else {
          this.itemsSAP.forEach((e) => {
            e.OddTaxPercentage = parseFloat(this.tax.DedHelper).toFixed(4);
            e.TaxCode = this.tax.DedAbbreviation;
            this.changeItem(e);
          });
          this.selectedTax = true;
        }
    },
    dblClick(item) { },
    createCircuit(item) {
      console.log("ordData", this.ordData);
      this.$fun.alert("Guardar con " + this.selectedCircuit[0].AccName, "question").then((r) => {
        if (r.value) {
          this.orderLocal.UsrUpdateID = this.selectedCircuit[0].AccID;
          this.ordData.UsrUpdateID = this.selectedCircuit[0].AccID;
          this.ordData.SecStatus = 1;
          this.dialogCircuit = false;
          this.orderLocal.Detail = this.itemsSAP;
          this.ordData.OrdStatus = 4;
          // this.orderLocal.Detail = [];

          _sOrderPurchase.save(this.ordData, this.$fun.getUserID(), this.selectedCircuit[0].AccID).then(async (r) => {
            this.$emit("onCloseClear");
            this.$fun.alert("Agregado Correctamente", "success");
            this.$emit("close");
            this.$emit("onClose");
            if (this.typeOrder == 3) {
              this.$emit("clearItemsCard");
            } else if (this.typeOrder == 1) {
              this.$emit("clearItemsCard");
            }
          });
        }
      });
    },
    rowClickCircuit: function (item, row) {
      this.selectedCircuit = [item];
      this.filterLevels = { AccID: item.AccID };
    },
    async save() {

      // console.log(this.Supplier);
      // console.log("this.itemsSAP:",this.itemsSAP);

      if (this.orderLocal.OrdGoodService == undefined || this.orderLocal.OrdGoodService == 0) {
        this.$fun.alert("Debe agregar el tipo de bien y servicio", "warning");
        return;
      }

      if (this.Supplier == null) {
        this.$fun.alert("Falta proveedor", "warning");
        return;
      }
      if (this.Attach1 == null) {
        this.$fun.alert("Falta adjuntar archivo", "warning");
        return;
      }
      if (this.itemsSAP.length < 1) {
        this.$fun.alert("Falta Items", "warning");
        return;
      }
      for (let i = 0; i < this.itemsSAP.length; i++) {
        if (this.itemsSAP[i].OddQuantity == null || this.itemsSAP[i].OddQuantity <= 0) {
          this.$fun.alert("Cantidad inválida, " + this.itemsSAP[i].OddDescription, "warning");
          return;
        }
        if (this.itemsSAP[i].OddDescription) {
          if (this.itemsSAP[i].OddDescription.trim().length < 1) {
            this.$fun.alert("Falta Descripción", "warning");
            return;
          }
        } else {
          this.$fun.alert("Falta Descripción", "warning");
          return;
        }
        if (this.itemsSAP[i].ItemGroupName === 'Activos Fijos' && (!this.itemsSAP[i].PrjCode || this.itemsSAP[i].PrjCode === '00000')) {
          this.$fun.alert("El articulo " + this.itemsSAP[i].OddDescription + " es activo fijo, debe pertenecer a un proyecto", "warning");
          return;
        }
        if (this.itemsSAP[i].OddUnitPrice == null || this.itemsSAP[i].OddUnitPrice == 0) {
          this.$fun.alert("Precio inválido, " + this.itemsSAP[i].OddDescription, "warning");
          return;
        }
        if (this.itemsSAP[i].CceID == null) {
          this.$fun.alert("Falta Centro de Costo en, " + this.itemsSAP[i].OddDescription, "warning");
          return;
        }
        if (this.itemsSAP[i].BslID == null) {
          this.$fun.alert("Falta Linea de Negocio en, " + this.itemsSAP[i].OddDescription, "warning");
          return;
        }
        if (this.itemsSAP[i].TypeCost == null) {
          this.$fun.alert("Falta Tipo de Costo, " + this.itemsSAP[i].OddDescription, "warning");
          return;
        }
        if (this.itemsSAP[i].TaxCode == null) {
          this.$fun.alert("Agrege Impuesto a, " + this.itemsSAP[i].OddDescription, "warning");
          return;
        }
        if (this.itemsSAP[i].OddUnitPrice == null || this.itemsSAP[i].OddUnitPrice == 0) {
          this.$fun.alert("Precio inválido, " + this.itemsSAP[i].OddDescription, "warning");
          return;
        }
        if (this.typeOrder == 3) {
          if (this.itemsSAP[i].OddAccount == null) {
            this.$fun.alert("Agrege Concepto a, " + this.itemsSAP[i].OddDescription, "warning");
            return;
          }
          // this.itemsSAP[i].OddQuantity = 1;
        }
        this.itemsSAP[i].TypeCurrency = this.orderLocal.TypeCurrency;
        // console.log("this.itemsSAP[i]",this.itemsSAP[i]);
        this.itemsSAP[i].SisCode = this.itemsSAP[i].SisID;
        this.itemsSAP[i].SitCode = this.itemsSAP[i].SitID;
      }

      // Validación CAPEX grupal: se valida al final, una sola vez por presupuesto único
      if (this.ValidateBudget == 1) {
        const capexOk = await this.validarCAPEXTodos();
        if (!capexOk) return;
      }

      this.orderLocal.Detail = this.itemsSAP;

      this.orderLocal.SupCode = this.Supplier.SupID;
      this.orderLocal.SupName = this.Supplier.SupName;
      this.orderLocal.OrdAttach1 = this.Attach1 != null ? this.Attach1.name : "";
      this.orderLocal.OrdAttach2 = this.Attach2 != null ? this.Attach2.name : "";
      this.orderLocal.OrdAttach3 = this.Attach3 != null ? this.Attach3.name : "";
      this.orderLocal.OrdAttach4 = this.Attach4 != null ? this.Attach4.name : "";
      this.orderLocal.CardName = this.Supplier.SupName;
      this.orderLocal.OrdDate = this.dateOrder;
      this.orderLocal.UsrUpdateID = this.$fun.getUserID();
      this.orderLocal.OrdDiscuont = this.orderLocal.OrdDiscountAmount || 0;
      // console.log("orderLocal", this.orderLocal);

      this.$fun.alert("Seguro de guardar?", "question").then((r) => {
        if (r.value) {
          this.orderLocal.Detail.push(...this.itemsRemove);

          let files = [];
          if (this.Attach1) files.push(this.Attach1);
          if (this.Attach2) files.push(this.Attach2);
          if (this.Attach3) files.push(this.Attach3);
          if (this.Attach4) files.push(this.Attach4);
          var formData = new FormData();
          let i = 0;
          files.forEach((element) => {
            formData.append(i.toString(), element);
            i++;
          });
          _sGeneral.uploadfile("123", this.$fun.getUserID(), formData, 3).then((r) => {
            // console.log("respuesta de upload", r);
            if (r.status === 200) {
              _sOrderPurchase.save(this.orderLocal, this.$fun.getUserID(), 0).then(async (r) => {
                console.log(JSON.parse(JSON.stringify({ r })))
                // actualizar presupuesto comprometido
                if (this.ValidateBudget == 1) {
                  const itemsToBudget = (r.data.Circuits && r.data.Circuits.length > 1) ? r.data.Order.Detail : r.data[0].Detail;
                  await this.updateBudgetForAllProjects(itemsToBudget);
                }

                if (r.data.Circuits && r.data.Circuits.length > 1) {
                  this.ordData = {};
                  this.circuits = r.data.Circuits;
                  this.ordData = r.data.Order;
                  this.dialogCircuit = true;
                } else {
                  this.$fun.alert("Guardado Correctamente", "success");
                  this.$emit("onClose");
                }

              });
            } else {
              this.$fun.alert("Error al subir archivos, intentelo nuevamente", "warning");
            }
          });
        }
      });

      // this.$fun.alert("Seguro de guardar?", "question").then((r) => {
      //   if (r.value) {
      //     this.orderLocal.Detail.push(...this.itemsRemove);

      //     _sOrderPurchase
      //       .save(this.orderLocal, this.$fun.getUserID(), 0)
      //       .then((r) => {
      //         if (r.data.length > 1) {
      //           console.log("ingreso al if");
      //           this.circuits = r.data;
      //           this.dialogCircuit = true;
      //         } else {
      //           console.log("ingreso al else");
      //           let files = [];
      //           if (this.Attach1) files.push(this.Attach1);
      //           if (this.Attach2) files.push(this.Attach2);
      //           if (this.Attach3) files.push(this.Attach3);
      //           if (this.Attach4) files.push(this.Attach4);
      //           var formData = new FormData();
      //           let i = 0;
      //           files.forEach((element) => {
      //             formData.append(i.toString(), element);
      //             i++;
      //           });
      //           _sGeneral.uploadfile("123", this.$fun.getUserID(), formData, 3)
      //           .then((r) => {
      //             console.log("respuesta de upload", r);
      //           });

      //           this.$fun.alert("Guardado Correctamente", "success");
      //           this.$emit("onClose");
      //         }
      //       });
      //   }
      // });
    },

    // Valida el presupuesto CAPEX para todos los items CAPEX de la orden de una sola vez.
    // Agrupa los items por (PrjCode + BslID), consulta el presupuesto una vez por grupo
    // y verifica que la suma total del grupo no supere el saldo disponible.
    async validarCAPEXTodos() {
      // Filtrar solo items CAPEX (tienen proyecto distinto de "00000" y tienen BslID)
      const itemsCapex = this.itemsSAP.filter(i => i.PrjCode && i.PrjCode !== '00000');
      if (itemsCapex.length == 0) return true;

      // Agrupar por PrjCode + BslID para hacer una sola consulta por presupuesto
      const grupos = {};
      itemsCapex.forEach(i => {
        console.log(JSON.parse(JSON.stringify({ i })));
        const key = `${i.PrjCode}|${i.BslID}`;
        if (!grupos[key]) grupos[key] = { PrjCode: i.PrjCode, BslID: i.BslID, items: [] };
        grupos[key].items.push(i);
      });

      const tipoCambio = await this.getExchangeRate(new Date(), 'US$');
      if (!tipoCambio) {
        this.$fun.alert(`NO SE ENCONTRÓ TIPO DE CAMBIO`, 'warning');
        return false;
      }

      // Validar cada presupuesto único
      for (const key of Object.keys(grupos)) {
        const grupo = grupos[key];
        const budget = await this.getBudget(grupo);

        if (!budget) {
          this.$fun.alert(`NO SE ENCONTRÓ PRESUPUESTO PARA EL PROYECTO (${grupo.PrjCode}) / LÍNEA DE NEGOCIO (${grupo.BslID})`, 'warning');
          return false;
        }

        // Sumar el OddAmount de todos los items de este grupo
        // OddAmount ya es el subtotal (precio × cantidad con impuesto y descuento aplicados)
        const totalGrupo = grupo.items.reduce((acc, i) => acc + (parseFloat(i.OddAmount) || 0), 0);
        let totalGrupoPEN = 0;
        let totalGrupoUSD = 0;

        if (this.orderLocal.TypeCurrency == 2) {
          totalGrupoPEN = parseFloat(totalGrupo * parseFloat(budget.BgtRatePrice)).toFixed(3);
          totalGrupoUSD = parseFloat(totalGrupo).toFixed(3);
        } else {
          totalGrupoPEN = parseFloat(totalGrupo).toFixed(3);
          totalGrupoUSD = parseFloat(totalGrupo / parseFloat(budget.BgtRatePrice)).toFixed(3);
        }

        const saldoDisponiblePEN = parseFloat(budget.BgtAvailableBalance);

        console.log(`PrjCode=${grupo.PrjCode}` + ` | Saldo proy. PEN: ${saldoDisponiblePEN}` + ` | Total PEN: ${totalGrupoPEN} | Total USD: ${totalGrupoUSD}`);

        if (totalGrupoPEN > saldoDisponiblePEN) {
          this.$fun.alert(`PRESUPUESTO INSUFICIENTE para Proyecto ${grupo.PrjCode}.\n` + `Saldo disponible: ${saldoDisponiblePEN.toFixed(2)}`, 'warning');
          return false;
        }

        if (saldoDisponiblePEN <= 0) {
          this.$fun.alert(`EL PRESUPUESTO NO TIENE SALDO DISPONIBLE para Proyecto ${grupo.PrjCode}.`, 'warning');
          return false;
        }
      }

      return true;
    },

    async getExchangeRate(date, currencyType) {
      try {
        const result = await _sOtherSupportService.exchangeratesap(date, currencyType, this.$fun.getUserID());
        if (result.status == 200 && result.data && result.data.Rate) {
          console.log("Tasa de cambio:", result.data);
          return result.data.Rate;
        }
        return null;
      } catch (error) {
        console.log("Error al obtener la tasa de cambio:", error);
        return null;
      }
    },

    async getBudget(item) {
      const usrID = this.$fun.getUserID();
      const year = this.dateOrder ? this.dateOrder.split('-')[0] : new Date().getFullYear();
      const userInfo = this.$fun.getUserInfo();
      const AreID = (userInfo && userInfo.CtrContract) ? (userInfo.CtrContract.AreID ?? 0) : 0;

      if (!AreID) {
        this.$fun.alert('NO SE ENCONTRÓ AREA DEL USUARIO', 'warning');
        return null;
      }

      const params = {
        PrjCode: item.PrjCode,
        AreID: AreID,
        BslID: item.BslID,
        BgtYear: year,
      };

      const resultadoBudget = await TrsBudgeService.list(params, usrID);
      console.log(JSON.parse(JSON.stringify({ params, resultadoBudget })));

      if (resultadoBudget.status == 200 && resultadoBudget.data.length > 0) {
        return resultadoBudget.data[0];
      }
      return null;
    },

    // Actualiza BgtReservedBalance sumando el OddAmount total de los items
    // de la orden que apuntan al mismo presupuesto (PrjCode + BslID).
    async updateBudgetDatabase(item, items = []) {
      const budget = await this.getBudget(item);
      if (!budget) {
        console.log('updateBudget: no se encontró presupuesto para', item.PrjCode, item.BslID);
        return;
      }

      // Sumar OddAmount de todos los items que usan este presupuesto
      // OddAmount ya es el subtotal con impuesto y descuento aplicados

      // OJO::::: ESTO YA LO HACE EL STORE PROCEDURE DE GUARDAR EL DESCONTAR
      // const nuevoReserved = items.filter(i => i.PrjCode == item.PrjCode && i.BslID == item.BslID)
      //   .reduce((acc, i) => acc + (parseFloat(i.OddAmount) || 0), 0);

      // const newAmountComprometido = parseFloat(budget.BgtReservedBalance) + nuevoReserved;
      // const budgetToSave = {
      //   ...budget,
      //   BgtReservedBalance: parseFloat(newAmountComprometido.toFixed(3)),
      //   UsrCreateID: this.$fun.getUserID(),
      // };

      try {
        // const result = await TrsBudgeService.save(budgetToSave, this.$fun.getUserID());
        // if (result.status == 200) {
        //   console.log(`Presupuesto ${budget.BgtID} actualizado correctamente.`);
        // Guardar el detalle de movimientos para los items de este presupuesto
        const groupItems = items.filter(i => i.PrjCode == item.PrjCode && i.BslID == item.BslID);
        const usrID = this.$fun.getUserID();
        const ordDate = this.dateOrder || null;


        const saves = groupItems.map(groupItem => {

          const BdgAmount = groupItem.TypeCurrency == 2 ? (groupItem.OddAmount * budget.BgtRatePrice).toFixed(3) : (groupItem.OddAmount).toFixed(3);
          const BgdAmountUSD = groupItem.TypeCurrency == 2 ? (groupItem.OddAmount).toFixed(3) : (groupItem.OddAmount / budget.BgtRatePrice).toFixed(3);

          const modelDetail = {
            BgdID: 0,
            BgtID: budget.BgtID,
            BgdDescription: groupItem.OddDescription || '',
            BgdAmount: parseFloat(BdgAmount) || 0,
            BgdRatePrice: budget.BgtRatePrice,
            BgdCurrencyType: groupItem.TypeCurrency,
            BgdAmountUSD,
            BgdOperationType: 1,          // Restar
            BgdDate: ordDate,
            BdgReqID: groupItem.ReqID || null,  // ID Requerimiento origen (si aplica)
            BdgReference: groupItem.ReqID ? 2 : 3, // //Si hay ReqId ? REQUERIMIENTO : ORDEN COMPRA
            BdgReferenceID: groupItem.OddID || null, // ID linea de orden (OddID)
            BdgState: 1,                  // 1 = Comprometido
            SecStatus: 1,
            UsrCreateID: usrID,
          };

          console.log(JSON.parse(JSON.stringify({ modelDetail })));
          return TrsBudgetDetailService.save(modelDetail, usrID)
            .then(r => console.log(`[BudgetDetail] BgtID=${budget.BgtID} item saved`, r.status))
            .catch(err => console.log('[BudgetDetail] Error guardando detalle:', err));
        });

        await Promise.all(saves);
        // }
      } catch (error) {
        console.log('Error al actualizar detalle del presupuesto:', error);
      }
    },

    // Itera todos los presupuestos únicos (PrjCode+BslID) afectados por los items
    // de la orden y actualiza su BgtReservedBalance en paralelo.
    async updateBudgetForAllProjects(items = []) {

      // const tipoCambio = await this.getExchangeRate(new Date(), 'US$');
      const seen = new Set();
      const uniqueItems = items.filter(i => {
        if (!i.PrjCode || i.PrjCode === '00000') return false;
        const key = `${i.PrjCode}|${i.BslID}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      await Promise.all(uniqueItems.map(i => this.updateBudgetDatabase(i, items)));
    },


  },

  created() {
    this.getGoodServiceList();
    _sGenParam.search({ PrmName: "ValidateBudget" }, this.$fun.getUserID()).then(resp => {
      this.ValidateBudget = resp.data.PrmValue;
    });
    this.orderLocal.TypeOrder = 3;
    this.orderLocal.TypeOrder = 1;

    this.orderLocal.ManagerPurchase = this.$fun.getUserSAPInfo().UssWorkerID;
    _sRequirement.ConceptService(this.$fun.getUserID()).then((r) => {
      this.itemsConcept = r.data;
      if (this.itemsConcept.length > 0)
        this.ConName = this.itemsConcept[0].ConName;
    });
  },
  watch: {
    "orderLocal.TypeOrder"() {
      this.itemsSAP = [];
      this.typeOrder = this.orderLocal.TypeOrder;
      if (this.orderLocal.TypeOrder == 3) {
        //this.headersSAP=[];
        this.headersSAP.splice(1, 3, {
          text: "Cuenta Mayor",
          value: "AcoName",
          width: 220,
          sortable: false,
        });
        this.headersSAP.splice(0, 0, {
          text: "Atendido",
          value: "OddQuantity",
          sortable: false,
        });
      } else if (this.orderLocal.TypeOrder == 1) {
        this.headersSAP.splice(
          1,
          1,
          { text: "N° Art.", value: "ArtCode", sortable: false, width: 50 },
          { text: "Und", value: "UnitMeasurement", sortable: false },
          { text: "Atendido", value: "OddQuantity", sortable: false }
        );
      }
    },
    ConName() {
      // console.log("Datawert1y2u3", this.ConName);
      _sRequirement
        .AccountConceptService(this.ConName, this.$fun.getUserID())
        .then((ar) => {
          this.itemsAccount = ar.data;
          // console.log("itemsAccount ED:", this.itemsAccount, this.AcoID);
          if (this.itemsAccount.length > 0) this.AcoID = this.itemsAccount[0];
        });
    },
    Supplier() {
      if (this.Supplier != null)
        if (this.Supplier.SupID != null) this.SupID = this.Supplier.SupID;
    },
  },
};
</script>